import Util from '@/modules/Util'
import QuizContent from '@/components/QuizContent'
import QuizHeaderText from '@/components/QuizHeaderText'
import QuizReleaseDate from '@/components/QuizReleaseDate'
import QuizTerm from '@/components/QuizTerm'
import QuizButton from '@/components/QuizButton'
import QuizText from '@/components/QuizText'
import QuizQuestion from '@/components/QuizQuestion'
import QuizQuestionImage from '@/components/QuizQuestionImage'
import QuizBody from '@/components/QuizBody'

export default {
  components: {
    QuizContent,
    QuizHeaderText,
    QuizReleaseDate,
    QuizTerm,
    QuizButton,
    QuizText,
    QuizQuestion,
    QuizQuestionImage,
    QuizBody
  },
  props: {
    page_number: {
      type: Number,
      required: true
    },
    qm_list: {
      type: Array,
      required: true
    },
    qsm_lists: {
      type: Array,
      required: true
    }
  },
  computed: {
    /**
     * 現在のページに応じたリストに絞って返す
     */
    limitedQmList () {
      return Util.limitedQmList(this.page_number, this.qm_list)
    }
  }
}
